const newLocal = "FETCH_FUTURE_ACTIVITIES"
const newLocal2 = "DELETE_WEEK"

export default (state = [], action) => {
    switch (action.type){
        case newLocal:
            return action.payload
        case newLocal2:
            return  {...state,entries:state.entries.filter(item => item.id != action.payload)}
        default:
            return state
    }
}